// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --first-color: #155263;
    --second-color: #ff6f3c;
    --third-color: #ff9a3c;
    --fourth-color: #ffc93c;
}

.App {
    text-align: center;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    font-size: 11pt;
}

/* -----------------------------------------------------------------------------
 * PAGE
 * -------------------------------------------------------------------------- */

.page {
    height: 100vh;
}

/* -----------------------------------------------------------------------------
 * MENU CONTAINER & MENU
 * -------------------------------------------------------------------------- */

.sidebar {
    height: 100vh;
    vertical-align: top;
    /* overflow: scroll; */
    background-color: #f0f0f0;
}

.menu-container {
    /* height: 100vh; */
    vertical-align: top;
    overflow: scroll;
    background-color: #f0f0f0;
}

.menu {
    /* background-color: #F0F0F0; */
    margin: 0px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 3px;
    padding-top: 3px;
    gap: 0px;
    text-align: left;
}
.menu table {
    margin-top: 5px;
}

.menu table tr {
    margin-top: 0px;
}

.menu table td {
    margin: 0px;
}

.menu table th {
    margin: 0px;
}

input {
    text-align: right;
    width: 80px;
    font-family: Roboto, "Helvetica Neue", sans-serif; /* monospace digits ; see alse <Text style={{fontVariant: ['tabular-nums']}}> */
}

button.cross {
    background-color: transparent;
    border-width: 0em;
    color: lightgrey;
}

button.cross:hover {
    color: grey;
}

button.cross:active {
    color: darkred;
}

table {
    padding: 0px;
    margin: 0px;
    border-collapse: collapse;
}

table th {
    font-weight: 300;
    padding-right: 3px;
    margin: 0px;
}

table td {
    margin: 0px;
    padding-left: 0px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 2px;
}

div.card {
    background-color: #fefefe;
    margin: 5px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-top: 0px;
    gap: 0px;
    text-align: left;
}

/* ------------------------------- */

a {
    color: black;
    text-decoration: none;
}

a:hover {
    color: darkorchid;
    cursor: grab;
}

h1 {
    color: var(--first-color);
    font-size: x-large;
    /* background-color: lightskyblue; */
}

h2 {
    color: var(--first-color);
    font-size: large;
    padding-top: 20px;
    padding-bottom: 0px;
    margin-bottom: 0px;
}

p {
    text-align: justify;
}

/* ------------------------------- */

.data-table td,
.data-table th {
    padding-left: 5px;
    padding-right: 5px;
    border-left: solid 1px lightgray;
    border-right: solid 1px lightgray;
}

.data-table th {
    font-size: small;
    background-color: #f0f0f0;
}

.data-table {
    border-collapse: collapse;
    margin-top: 5px;
    border: none;
    /* border-bottom: solid 1px lightgray;
    border-top: solid 1px lightgray; */
    td:nth-child(1) {
        text-align: center;
        border-left: none;
    }
    td:nth-child(2) {
        text-align: center;
    }
    td:nth-child(3) {
        text-align: left;
    }
    td:nth-child(5) {
        text-align: right;
    }
    td:nth-child(6) {
        text-align: right;
    }
    td:last-child {
        border-right: none;
    }

    th:nth-child(1) {
        text-align: center;
        border-left: none;
    }
    th:nth-child(2) {
        text-align: center;
    }
    th:nth-child(3) {
        text-align: left;
    }
    th:nth-child(5) {
        text-align: right;
    }
    th:nth-child(6) {
        text-align: right;
    }
    th:last-child {
        border-right: none;
    }

    tr:nth-child(even) {
        background-color: #f9f9e1;
    }
    width: 100%;
}

.c1 {
    color: #2aafe4;
}

.c2 {
    color: #49beb7;
}

.c3 {
    color: #daa949;
}

.c4 {
    color: #ee5959;
}

.c5 {
    color: violet;
}

p > ul {
    margin-top: 5px;
}

p > ul > li {
    margin-top: 5px;
}

#version-footer {
    bottom: 0;
}

.navigation-icon {
    /* vertical-align: bottom; */
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #daa949;
}

.navigation-icon:hover {
    color: coral;
}

.navigation-icon:active {
    color: darkred;
}

.small-text {
    margin-top: 3px;
    font-size: 9pt;
    margin-bottom: 3px;
}

.external-link {
    color: #007bff;
    text-decoration: none;
}

.external-link:hover {
    text-decoration: underline;
}

.no-bullets {
    list-style-type: none;
}

/* - SIMPLE VALUE TABLE ------------------------------ */

.simple-table td,
.simple-table th {
    padding-left: 5px;
    padding-right: 5px;
    border-left: solid 1px lightgray;
    border-right: solid 1px lightgray;
    border-top: solid 1px lightgray;
    border-bottom: solid 1px lightgray;
    text-align: center; /* Optional: Centers the text inside cells */
}

.simple-table th {
    font-size: small;
    background-color: #f0f0f0;
}

.simple-table {
    border-collapse: collapse;
    table-layout: fixed; /* Ensures the table layout is fixed */
    margin-top: 5px;
    margin-bottom: 10px;
    width: 100%;
    border-left: solid 1px lightgray;
    border-right: solid 1px lightgray;
}

/* --- TOC ---------------------------- */

.page > span {
    height: 100%;
    width: 100%;
}

.chapter-container {
    display: flex;
    flex-direction: row;
    /*align-items: center; */
    /* width: 100%; */
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: 100%;
}

.toc {
    position: absolute;
    top: 0;
    right: 0;
    max-height: 100vh;
    overflow-y: auto;
    padding: 1rem;
    background-color: #f0f0f0;
    width: 150px;
    text-align: left;
}

.toc ul {
    list-style: none;
    padding: 0;
}

.toc li {
    margin: 0.5rem 0;
    cursor: pointer;
    color: #404040;
}

.toc li:hover {
    /* text-decoration: underline; */
    color: darkorchid;
    /* cursor: grab; */
}

div.centered-content {
    width: 710px;
    max-width: 710px;
    min-width: 710px;
    height: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    margin: 0;
    overflow: scroll;
}

.trig {
    margin-top: 40px;
    font-size: small;
}

/* Jacobi */
.input-container {
    display: flex;
    gap: 40px;
    margin-bottom: 20px;
}

.matrix-input {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.vector-input {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
}

button {
    margin-right: 10px;
}

.jacobi {
    td:nth-child(1) {
        text-align: right;
    }
    td:nth-child(2) {
        text-align: right;
    }
    td:nth-child(3) {
        text-align: right;
    }

    th:nth-child(1) {
        text-align: right;
    }
    th:nth-child(2) {
        text-align: right;
    }
    th:nth-child(3) {
        text-align: right;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,eAAe;AACnB;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;AACjB;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iDAAiD,EAAE,+EAA+E;AACtI;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;AACpB;;AAEA,oCAAoC;;AAEpC;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oCAAoC;;AAEpC;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ;sCACkC;IAClC;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;IACA,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,wDAAwD;;AAExD;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;IACjC,+BAA+B;IAC/B,kCAAkC;IAClC,kBAAkB,EAAE,4CAA4C;AACpE;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB,EAAE,sCAAsC;IAC3D,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA,yCAAyC;;AAEzC;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[":root {\n    --first-color: #155263;\n    --second-color: #ff6f3c;\n    --third-color: #ff9a3c;\n    --fourth-color: #ffc93c;\n}\n\n.App {\n    text-align: center;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    font-size: 11pt;\n}\n\n/* -----------------------------------------------------------------------------\n * PAGE\n * -------------------------------------------------------------------------- */\n\n.page {\n    height: 100vh;\n}\n\n/* -----------------------------------------------------------------------------\n * MENU CONTAINER & MENU\n * -------------------------------------------------------------------------- */\n\n.sidebar {\n    height: 100vh;\n    vertical-align: top;\n    /* overflow: scroll; */\n    background-color: #f0f0f0;\n}\n\n.menu-container {\n    /* height: 100vh; */\n    vertical-align: top;\n    overflow: scroll;\n    background-color: #f0f0f0;\n}\n\n.menu {\n    /* background-color: #F0F0F0; */\n    margin: 0px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-bottom: 3px;\n    padding-top: 3px;\n    gap: 0px;\n    text-align: left;\n}\n.menu table {\n    margin-top: 5px;\n}\n\n.menu table tr {\n    margin-top: 0px;\n}\n\n.menu table td {\n    margin: 0px;\n}\n\n.menu table th {\n    margin: 0px;\n}\n\ninput {\n    text-align: right;\n    width: 80px;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif; /* monospace digits ; see alse <Text style={{fontVariant: ['tabular-nums']}}> */\n}\n\nbutton.cross {\n    background-color: transparent;\n    border-width: 0em;\n    color: lightgrey;\n}\n\nbutton.cross:hover {\n    color: grey;\n}\n\nbutton.cross:active {\n    color: darkred;\n}\n\ntable {\n    padding: 0px;\n    margin: 0px;\n    border-collapse: collapse;\n}\n\ntable th {\n    font-weight: 300;\n    padding-right: 3px;\n    margin: 0px;\n}\n\ntable td {\n    margin: 0px;\n    padding-left: 0px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-right: 2px;\n}\n\ndiv.card {\n    background-color: #fefefe;\n    margin: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-bottom: 5px;\n    padding-top: 0px;\n    gap: 0px;\n    text-align: left;\n}\n\n/* ------------------------------- */\n\na {\n    color: black;\n    text-decoration: none;\n}\n\na:hover {\n    color: darkorchid;\n    cursor: grab;\n}\n\nh1 {\n    color: var(--first-color);\n    font-size: x-large;\n    /* background-color: lightskyblue; */\n}\n\nh2 {\n    color: var(--first-color);\n    font-size: large;\n    padding-top: 20px;\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n}\n\np {\n    text-align: justify;\n}\n\n/* ------------------------------- */\n\n.data-table td,\n.data-table th {\n    padding-left: 5px;\n    padding-right: 5px;\n    border-left: solid 1px lightgray;\n    border-right: solid 1px lightgray;\n}\n\n.data-table th {\n    font-size: small;\n    background-color: #f0f0f0;\n}\n\n.data-table {\n    border-collapse: collapse;\n    margin-top: 5px;\n    border: none;\n    /* border-bottom: solid 1px lightgray;\n    border-top: solid 1px lightgray; */\n    td:nth-child(1) {\n        text-align: center;\n        border-left: none;\n    }\n    td:nth-child(2) {\n        text-align: center;\n    }\n    td:nth-child(3) {\n        text-align: left;\n    }\n    td:nth-child(5) {\n        text-align: right;\n    }\n    td:nth-child(6) {\n        text-align: right;\n    }\n    td:last-child {\n        border-right: none;\n    }\n\n    th:nth-child(1) {\n        text-align: center;\n        border-left: none;\n    }\n    th:nth-child(2) {\n        text-align: center;\n    }\n    th:nth-child(3) {\n        text-align: left;\n    }\n    th:nth-child(5) {\n        text-align: right;\n    }\n    th:nth-child(6) {\n        text-align: right;\n    }\n    th:last-child {\n        border-right: none;\n    }\n\n    tr:nth-child(even) {\n        background-color: #f9f9e1;\n    }\n    width: 100%;\n}\n\n.c1 {\n    color: #2aafe4;\n}\n\n.c2 {\n    color: #49beb7;\n}\n\n.c3 {\n    color: #daa949;\n}\n\n.c4 {\n    color: #ee5959;\n}\n\n.c5 {\n    color: violet;\n}\n\np > ul {\n    margin-top: 5px;\n}\n\np > ul > li {\n    margin-top: 5px;\n}\n\n#version-footer {\n    bottom: 0;\n}\n\n.navigation-icon {\n    /* vertical-align: bottom; */\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: #daa949;\n}\n\n.navigation-icon:hover {\n    color: coral;\n}\n\n.navigation-icon:active {\n    color: darkred;\n}\n\n.small-text {\n    margin-top: 3px;\n    font-size: 9pt;\n    margin-bottom: 3px;\n}\n\n.external-link {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.external-link:hover {\n    text-decoration: underline;\n}\n\n.no-bullets {\n    list-style-type: none;\n}\n\n/* - SIMPLE VALUE TABLE ------------------------------ */\n\n.simple-table td,\n.simple-table th {\n    padding-left: 5px;\n    padding-right: 5px;\n    border-left: solid 1px lightgray;\n    border-right: solid 1px lightgray;\n    border-top: solid 1px lightgray;\n    border-bottom: solid 1px lightgray;\n    text-align: center; /* Optional: Centers the text inside cells */\n}\n\n.simple-table th {\n    font-size: small;\n    background-color: #f0f0f0;\n}\n\n.simple-table {\n    border-collapse: collapse;\n    table-layout: fixed; /* Ensures the table layout is fixed */\n    margin-top: 5px;\n    margin-bottom: 10px;\n    width: 100%;\n    border-left: solid 1px lightgray;\n    border-right: solid 1px lightgray;\n}\n\n/* --- TOC ---------------------------- */\n\n.page > span {\n    height: 100%;\n    width: 100%;\n}\n\n.chapter-container {\n    display: flex;\n    flex-direction: row;\n    /*align-items: center; */\n    /* width: 100%; */\n    box-sizing: border-box;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.toc {\n    position: absolute;\n    top: 0;\n    right: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    padding: 1rem;\n    background-color: #f0f0f0;\n    width: 150px;\n    text-align: left;\n}\n\n.toc ul {\n    list-style: none;\n    padding: 0;\n}\n\n.toc li {\n    margin: 0.5rem 0;\n    cursor: pointer;\n    color: #404040;\n}\n\n.toc li:hover {\n    /* text-decoration: underline; */\n    color: darkorchid;\n    /* cursor: grab; */\n}\n\ndiv.centered-content {\n    width: 710px;\n    max-width: 710px;\n    min-width: 710px;\n    height: 100%;\n    flex-grow: 0;\n    flex-shrink: 0;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 0;\n    margin: 0;\n    overflow: scroll;\n}\n\n.trig {\n    margin-top: 40px;\n    font-size: small;\n}\n\n/* Jacobi */\n.input-container {\n    display: flex;\n    gap: 40px;\n    margin-bottom: 20px;\n}\n\n.matrix-input {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n}\n\n.vector-input {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 10px;\n}\n\nbutton {\n    margin-right: 10px;\n}\n\n.jacobi {\n    td:nth-child(1) {\n        text-align: right;\n    }\n    td:nth-child(2) {\n        text-align: right;\n    }\n    td:nth-child(3) {\n        text-align: right;\n    }\n\n    th:nth-child(1) {\n        text-align: right;\n    }\n    th:nth-child(2) {\n        text-align: right;\n    }\n    th:nth-child(3) {\n        text-align: right;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
